<template>
    <div class="container mt-4">
        <div class="row justify-content-center mb-4">
            <div class="col-md-10">
                <div class="form-group">
                    <label for="filterType">Filter by Type:</label>
                    <select
                        id="filterType"
                        class="form-control"
                        v-model="filters.type"
                    >
                        <option
                            v-for="type in types"
                            :key="type.value"
                            :value="type.value"
                        >
                            {{ type.label }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-10">
                <div v-if="loading" class="text-center">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
                <div v-else>
                    <!--begin::load content-->
                    <div v-if="filteredRequests.length > 0">
                        <div class="row" id="card_wrapper">
                            <transition-group name="fade-up" tag="div" class="row" appear>
                                <div
                                    v-for="(request) in filteredRequests"
                                    :key="request.id"
                                    class="col-md-6 col-lg-4 mb-4"
                                >
                                    <div class="card shadow">
                                        <div class="card-header flex-column">
                                            <h5 class="card-title mb-3">
                                                {{ preventNullTitle(request.title) }}
                                            </h5>
                                            <!--begin::type-->
                                            <div class="d-flex pb-2 pb-sm-0">
                                                <span
                                                    v-if="request.type === 'penawaran'"
                                                    class="badge badge-sm bg-success"
                                                >
                                                    Penawaran
                                                </span>
                                                <span
                                                    v-else
                                                    class="badge badge-sm bg-warning"
                                                >
                                                    Permintaan
                                                </span>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <p class="card-text">
                                                <strong>Peminatan</strong>
                                                {{ request.bidang_peminatan }}
                                            </p>
                                            <p class="card-text">
                                                <strong>Domisili: </strong>
                                                {{ request.location }}
                                            </p>
                                            <p class="card-text">
                                                <strong>Tampil Sampai: </strong>
                                                {{ request.show_end_date }}
                                            </p>
                                            <div class="contact-info">
                                                <p>
                                                    <strong>Oleh:</strong>
                                                    {{
                                                        request.request_by
                                                            .full_name_with_title
                                                    }}
                                                </p>
                                                <p>
                                                    <strong>Email:</strong>
                                                    {{ request.request_by.email }}
                                                </p>
                                                <p>
                                                    <strong>WhatsApp:</strong>
                                                    {{
                                                        request.request_by
                                                            .whatsapp_number
                                                    }}
                                                </p>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <a
                                                    :href=request.detail_path
                                                    class="btn btn-apply w-100 mt-3"
                                                    >Detail</a
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </transition-group>
                        </div>
                    </div>
                    <div v-else>
                        <div class="alert alert-info" role="alert">
                            Tidak ada penawaran / permintaan magang saat ini.
                        </div>
                    </div>
                    <!--end::load content-->
                </div>
                <!--begin:: pagination link page-->
                <div v-if="pagination != null" class="row justify-content-center mt-4 z-2">
                    <!--begin::total number of data-->
                    <div class="col-md-4">
                        <p class="text-center">
                            Menampilkan
                            <strong>{{ pagination.from }}</strong>
                            sampai
                            <strong>{{ pagination.to }}</strong>
                            dari
                            <strong>{{ pagination.total }}</strong>
                            data
                        </p>
                    </div>
                    <!--begin::navigation-->
                    <div class="col-md-5">
                        <nav aria-label="Page navigation example">
                            <ul class="pagination justify-content-center">
                                <!-- Previous Button -->
                                <li class="page-item" :class="{ disabled: !pagination.prev_page_url }">
                                    <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1)" :disabled="!pagination.prev_page_url">Previous</a>
                                </li>

                                <!-- Page Numbers -->
                                <li v-for="page in listOfPages" :key="page" class="page-item" :class="{ active: page === pagination.current_page }">
                                    <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                                </li>

                                <!-- Next Button -->
                                <li class="page-item" :class="{ disabled: !pagination.next_page_url }">
                                    <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1)" :disabled="!pagination.next_page_url">Next</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <!--end::navigation-->
                    <!--begin::change number pagination-->
                    <div class="col-md-3 mt-3">
                        <div class="form-group text-center">
                            <label for="paginationNumber">Per page:</label>
                            <select
                                id="paginationNumber"
                                v-model="pagination.per_page"
                                @change="selectPaginationNumber"
                            >
                                <option
                                    v-for="number in paginationNumber"
                                    :key="number"
                                    :value="number"
                                    :selected="number == pagination.per_page"
                                >
                                    {{ number }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!--end::change number pagination-->
                    
                </div>
                <!--end:: pagination link page-->
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            requests: [],
            filters: {
                type: "all",
            },
            types: [
                {
                    value: "all",
                    label: "All",
                },
                {
                    value: "penawaran",
                    label: "Penawaran",
                },
                {
                    value: "permintaan",
                    label: "Permintaan",
                },
            ],
            loading: false,
            pagination: null,
            showAblePages: 5,
            lastFetchUrl: null,
            paginationNumber : ['9', '15', '30'],
            paginationNumberSelected: null,
            cardOffsetHeight: 0,
        };
    },
    computed: {
        filteredRequests() {
            if (this.filters.type === "all") {
                return this.requests;
            }
            return this.requests.filter(
                (request) => request.type === this.filters.type
            );
        },
        listOfPages() {
            const totalPages = this.pagination.last_page;
            const currentPage = this.pagination.current_page;

            // Define the maximum number of pages to show
            const maxPagesToShow = 5;
            let startPage = Math.max(currentPage - Math.floor(maxPagesToShow / 2), 1);
            let endPage = startPage + maxPagesToShow - 1;

            // Adjust start and end page if they exceed the total pages
            if (endPage > totalPages) {
                endPage = totalPages;
                startPage = Math.max(endPage - maxPagesToShow + 1, 1);
            }

            // Generate the list of pages
            const pages = [];
            for (let page = startPage; page <= endPage; page++) {
                pages.push(page);
            }

            return pages;
        },
    },
    methods: {
        fetchData(old = false, paramsKey = null, paramsValue = null) {
            this.loading = true;
            let url = "/member/magang/ajax/data/list";
            let queryParams = new URLSearchParams(); // Use URLSearchParams for easy query string manipulation

            if (paramsKey === 'filter') {
                queryParams.set('type', paramsValue);
            }

            if (paramsKey === 'page') {
                queryParams.set('page', paramsValue);

                if (this.filters.type !== 'all') {
                    queryParams.set('type', this.filters.type);
                }
            }

            if (paramsKey === 'pagination' || this.paginationNumberSelected !== null) {
                queryParams.set('per_page', this.paginationNumberSelected || '9');

                if (this.filters.type !== 'all') {
                    queryParams.set('type', this.filters.type);
                }

                if (paramsKey === 'page') {
                    queryParams.set('page', paramsValue);
                }
            }

            if (old) {
                url = this.lastFetchUrl;
            } else {
                const queryString = queryParams.toString();
                if (queryString) {
                    url += `?${queryString}`;
                }
                this.lastFetchUrl = url;
            }

            axios.get(url, {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        "Accept": "application/json",
                    },
                })
                .then((response) => {
                    const json = response.data;
                    this.requests = json.data;
                    this.pagination = json.pagination;
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        preventNullTitle(title) {
            return title ? title : "No Title";
        },
        changePage(page) {
            if (page < 1 || page > this.pagination.last_page) return;
            
            this.pagination.current_page = page;

            this.fetchData(false, 'page', page);
        },

        selectPaginationNumber(event) {
            this.paginationNumberSelected = event.target.value;
            this.fetchData(false, 'pagination', this.paginationNumberSelected);
        },
    },
    mounted() {
        this.fetchData();
        setInterval(() => {
            this.fetchData(true);
        }, 180000);
    },
    watch: {
        filters: {
            handler: function (val) {
                this.fetchData(false, 'filter', val.type);
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
.card {
    border: none;
    border-radius: 15px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s;
}

.fade-up-enter-active {
    transition: opacity 0.5s, transform 0.5s, display 0.20s;
    transition-delay: .5s;
}

.fade-up-leave-active {
    transition: opacity 0.5s, transform 0.5s , display 0.20s;
}

.fade-up-enter-from, .fade-up-leave-to {
    display: none;
    opacity: 0;
    transform: translateY(20px);
}

.fade-up-enter-to, .fade-up-leave {
    display: block;
    opacity: 1;
    transform: translateY(0);
}

.fade-up-enter, .fade-up-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}

.card:hover {
    transform: scale(1.02);
}

.card-body {
    padding: 1.5rem;
}

.card-header {
    background-color: #026602;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    padding: 1rem;
}

.card-title {
    color: #fff !important;
    margin: unset;
}

.btn-apply {
    background-color: #026602;
    color: #fff;
    font-weight: 500;
    border-radius: 30px;
}

.btn-apply:hover {
    background-color: #36df36;
    color: #fff;
}

.btn-radius {
    border-radius: 30px;
}

.contact-info {
    background-color: #f8f9fa;
    border-radius: 10px;
    padding: 1rem;
    margin-top: 1.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.contact-info p {
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
}

.contact-info strong {
    color: #0d6efd;
}

.z-2 {
    position: relative;
    z-index: 2;
}
</style>
